var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "myModal",
          staticClass: "fixedModal",
          attrs: {
            size: "lg",
            id: "modal1",
            title: "Info " + _vm.localType,
            centered: "",
            "hide-footer": true
          },
          on: { hidden: _vm.onHidden }
        },
        [
          _vm.localType === "comercial"
            ? [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c("p", [
                        _c("span", { staticClass: "square cliente" }),
                        _vm._v(' "Ya es cliente"')
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square con-gas" }),
                        _vm._v(' Potencial "Con gas en finca"')
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square sin-gas" }),
                        _vm._v(' Potencial "Sin gas en finca"')
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square desconocido" }),
                        _vm._v(' Potencial "Gas en finca desconocido"')
                      ])
                    ])
                  ],
                  1
                )
              ]
            : _vm.localType === "caldera"
            ? [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c("p", [_c("strong", [_vm._v("Tipo suministro")])]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square" }),
                        _vm._v("Finca con caldera principal")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "circle" }),
                        _vm._v("Finca suministrada")
                      ]),
                      _vm._v(" "),
                      _c("p", [_c("strong", [_vm._v("Tipo Servicio")])]),
                      _vm._v(" "),
                      _c("p", [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/icons/calefaccion.png"),
                            alt: "Calefaccion"
                          }
                        }),
                        _vm._v(" Calefacción")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/icons/acs.png"),
                            alt: "ACS"
                          }
                        }),
                        _vm._v(" ACS")
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/icons/calefaccion-acs.png"),
                            alt: "Calefaccion y ACS"
                          }
                        }),
                        _vm._v(" Calefacción y ACS")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-col", [
                      _c("p", [
                        _c("span", { staticClass: "square cliente" }),
                        _vm._v(' "Ya es cliente"')
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square con-gas" }),
                        _vm._v(' Potencial "Con gas en finca"')
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square sin-gas" }),
                        _vm._v(' Potencial "Sin gas en finca"')
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticClass: "square desconocido" }),
                        _vm._v(' Potencial "Gas en finca desconocido"')
                      ])
                    ])
                  ],
                  1
                )
              ]
            : _vm.localType === "territorio"
            ? [
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_zonasgn.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Zonas Nedgia (Zoom 5-7)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_provincias.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Provincias (Zoom 8-10)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_municipios.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Municipios (Zoom 11-15)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_codigospostales.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Códigos Postales (Zoom 14-18)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_areasnognd.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Zonas no Nedgia (Zoom 5-21)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_secciones.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Secciones censales (Zoom 16-22)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_nucleos.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Núcleos urbanos (Zoom 11-13)\n      ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_exencionalta_borde.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v(
                    "\n        Exención derechos de alta (Zoom 11-17)\n      "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/icons/territorio_exencioncanon_borde.png"),
                      height: "15",
                      width: "15"
                    }
                  }),
                  _vm._v(" "),
                  _vm._v("\n        Exención canon IRC (Zoom 11-17)\n      ")
                ])
              ]
            : _vm.localType === "red"
            ? [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", [_c("strong", [_vm._v("Subtramos")])]),
                            _vm._v(" "),
                            _c("b-col", [_c("strong", [_vm._v("GN")])]),
                            _vm._v(" "),
                            _c("b-col", [_c("strong", [_vm._v("GLP")])])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v("\n              Red APB\n            ")
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_apb.png"),
                                  alt: "Red APB GN"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_apb_glp.png"),
                                  alt: "Red APB GLP"
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v("\n              Red APA\n            ")
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_apa.png"),
                                  alt: "Red APA GN"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_apa_glp.png"),
                                  alt: "Red APA GLP"
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v("\n              Red MPB\n            ")
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_mpb.png"),
                                  alt: "Red MPB GN"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_mpb_glp.png"),
                                  alt: "Red MPB GLP"
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v("\n              Red MPA\n            ")
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_mpa.png"),
                                  alt: "Red MPA GN"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_mpa_glp.png"),
                                  alt: "Red MPA GLP"
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v("\n              Red BP\n            ")
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_bp.png"),
                                  alt: "Red BP GN"
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icons/red_bp_glp.png"),
                                  alt: "Red BP GLP"
                                }
                              })
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", [_c("strong", [_vm._v("Acometidas")])]),
                            _vm._v(" "),
                            _c("b-col")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v("\n              Acometidas\n            ")
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("span", {
                                staticClass: "rectangle",
                                staticStyle: { background: "#65ff00" }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _vm._v(
                                "\n              Acometidas enterradas\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("span", {
                                staticClass: "rectangle",
                                staticStyle: { background: "#ff9900" }
                              })
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/red_en_servicio.png"),
                          alt: "En servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("En servicio")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/red_en_construccion.png"),
                          alt: "En construccion"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("En construcción (con texto)")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/red_en_construccion.png"),
                          alt: "En proyecto"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("En proyecto (con texto)")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("strong", [_vm._v("Plantas GLP")]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/glp_glp_serv.png"),
                          alt: "Instalación GLP - En servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Instalación GLP - En servicio")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/glp_glp_fser.png"),
                          alt: "Instalación GLP - Fuera de servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Instalación GLP - Fuera de servicio")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/glp_botellas_serv.png"),
                          alt: "Botellas GLP - En servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Botellas GLP - En servicio")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/glp_botellas_fser.png"),
                          alt: "Botellas GLP - Fuera de servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Botellas GLP - Fuera de servicio")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("strong", [_vm._v("Plantas GNL")]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/gnl_gnl_serv.png"),
                          alt: "Instalación GNL - En servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Instalación GNL - En servicio")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/gnl_gnl_fser.png"),
                          alt: "Instalación GNL - Fuera de servicio"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Instalación GNL - Fuera de servicio")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("strong", [_vm._v("Gasineras")]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/gasinera-gnl.png"),
                          alt: "Gas Natural Licuado"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Gas Natural Licuado")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/gasinera-gnc.png"),
                          alt: "Gas Natural Comprimido"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Gas Natural Comprimido")])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/icons/gasinera-gnc_gnl.png"),
                          alt: "GNC-GNL"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("GNC-GNL")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("strong", [
                  _vm._v("Red inyeccion biogas - Caudal máximo (Nm3/h)")
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          < 100\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#fa1010" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          100 - 250\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#d77008" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          250 - 500\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#f4b81f" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          500 - 1000\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#f8f404" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          1000 - 1500\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#e2f81a" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          1500 - 2000\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#bcf640" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          2000 - 3000\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#93f321" }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _vm._v("\n          > 3000\n        ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("span", {
                        staticClass: "rectangle",
                        staticStyle: { background: "#20f60d" }
                      })
                    ])
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.localType === "residencial"
            ? [
                _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _vm._v("Unifamiliares")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _vm._v("Bifamiliares")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _vm._v("Plurifamiliares")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Con activos - con potencial")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/activas_uni_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/activas_bi_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/activas_pluri_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Con activos - sin potencial")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/activas_uni_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/activas_bi_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/activas_pluri_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Solo captados - con potencial")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/captadas_uni_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/captadas_bi_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/captadas_pluri_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Solo captados - sin potencial")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/captadas_uni_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/captadas_bi_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/captadas_pluri_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Sin activos - con potencial")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/no_activas_uni_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/no_activas_bi_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/no_activas_pluri_con.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Sin activos - sin potencial")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/no_activas_uni_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/no_activas_bi_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/no_activas_pluri_sin.png"),
                              alt: "Uni con activos",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", { attrs: { cols: "3" } }, [
                          _vm._v("Multifincas")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { "offset-md": "2" } }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icons/multifinca.png"),
                              alt: "Multifincas",
                              height: "19",
                              width: "19"
                            }
                          })
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/InfoPopUp.vue?vue&type=template&id=5ebaaba9&
// module id = null
// module chunks = 